<template>
    <div id="TopBar">
        <a href="/" id="Logo">MPL CRM</a>
    </div>
</template>

<script>
    export default {
        name: 'Header',
        data: function() {
            return {}
        },
    }
</script>

<style scoped>
    #TopBar {
        margin: 0;
        padding: 0;
        text-align: center;
        white-space: nowrap;
        background:#000;
        text-align: center;
    }
    #TopBar:before {
        content: '';
        display: inline-block;
        height: 100%;
        vertical-align: middle;
        margin-right: -0.25em;
    }

    #Logo {
        display: inline-block;
        vertical-align: middle;
        text-decoration: none;
        transition: 1s;
        font-size: 2rem;
        color: #FFF;
        padding: 0 1rem;
    }
    #Logo:hover,
    #Logo:focus {
        background: rgba(200,200,200,0.4);
    }
</style>